import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { map } from 'rxjs/operators';
import {AccountService} from "../../services";
import {environment} from "../../../../environments/environment";
import {CashReports} from "../model/cashReports";
import {CashReport} from "../model/cashReport";



@Injectable({ providedIn: 'root' })
export class CashReportService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAll(offset: number, limit: number) {
        let filtersString = '';

        return this.http.get<CashReports>(`${environment.apiEndpoint}/v1/cash-reports?offset=` + offset + `&limit=` + limit + filtersString, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getById(id: string) {
        return this.http.get<CashReport>(`${environment.apiEndpoint}/v1/cash-reports/${id}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getPdf(id: string) {
        return this.http.get<string>(`${environment.apiEndpoint}/v1/cash-reports/${id}/pdf`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getActive() {
        return this.http.get<CashReport>(`${environment.apiEndpoint}/v1/cash-reports/active/get`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getLast() {
        return this.http.get<CashReport>(`${environment.apiEndpoint}/v1/cash-reports/last/get`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    close(cashReport: CashReport, endDayCash: number, comments: string|null) {
        return this.http.post(`${environment.apiEndpoint}/v1/cash-reports/close/${cashReport.id}`, {
            endDayCash: endDayCash,
            comments: comments
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: CashReport) => {
                return x;
            }));
    }

    open(cashReport: CashReport, openDayCash: number, comments: string|null) {
        return this.http.post(`${environment.apiEndpoint}/v1/cash-reports/open/report`, {
            openDayCash: openDayCash,
            comments: comments
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: CashReport) => {
                return x;
            }));
    }
}
